const initialState = {
  email: "",
  mobilePhone: ""
};

export default initialState;
